module.exports = __webpack_public_path__ + "static/Kamil Awid.42f1974a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Kamil Awid.jpg
// module id = 1219
// module chunks = 6166952557895